import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
// import {Http, Response} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class AutoLoginService {
	constructor (
		private http: Http,

		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}


	// private lastVersionChecked = '';
	// private timeLastVersionChecked = 0;

	autoLogin: any = {
		enableAutoLogin: false,
		filmFreeway: Date.now(),
		withoutabox: Date.now(),
		vimeo: {
		}
	};


	touch(loginType: string, filmId: string = '') {		// tslint:disable-line
		console.log(`'AutoLoginService touch: ${loginType} ${filmId}`);
		if (!window.localStorage) {
			console.log('Browser does not support local storage.');
			return;
		}

		let autoLogin: any = {};
		let autoLoginString = localStorage.getItem('auto-login');
		if (autoLoginString) {
			autoLogin = JSON.parse(autoLoginString);
		}

		if (loginType === 'vimeo') {
			if (!filmId) {
				return;
			}

			autoLogin.vimeo = autoLogin.vimeo || {};
			autoLogin.vimeo[filmId] = Date.now();
		} else {
			autoLogin[loginType] = Date.now();
		}

		autoLoginString = JSON.stringify(autoLogin);
		localStorage.setItem('auto-login', autoLoginString);
	}


// TODO!!! - walk the full list of prior logins, purge any that have expired
	isLoggedIn(loginType: string, filmId: string = '') {		// tslint:disable-line
		if (!window.localStorage) {
			console.log('Browser does not support local storage.');
			return false;
		}

		let autoLoginString = localStorage.getItem('auto-login');
		if (!autoLoginString) {
			return false;
		}
		let autoLogin = JSON.parse(autoLoginString);

		if (loginType === 'vimeo') {
			// console.log('isLoggedIn, #1');
			if (!filmId) {
				return false;
			}
			// console.log('isLoggedIn, #2');

			// vimeos are logged in for 45 minutes
			let lastTouch = autoLogin.vimeo[filmId];
			if (!lastTouch) {
				return false;
			}
			// console.log('isLoggedIn, #3');

			// console.log('lastTouch:');
			// console.log(lastTouch);

			let toCompare = lastTouch + 45 * 60 * 1000;
			let now = Date.now();
			let diff = toCompare - now;
			if (diff > 0) {
				console.log('isLoggedIn, minutes remaining = ' + (diff / 60 / 1000) );
			} else {
				console.log('isLoggedIn, no longer logged in');
			}

			if (lastTouch + 45 * 60 * 1000 > Date.now()) {
				console.log('isLoggedIn, is logged in');
				return true;
			} else {
				console.log('isLoggedIn, is NOT logged in');
				return false;
			}
		} else if (loginType === 'filmFreeway') {
			// filmFreeways are logged in for 3 days - 5 minutes
			let lastTouch = autoLogin.filmFreeway;
			if (!lastTouch) {
				return false;
			}

			if (lastTouch + 3 * 24 * 60 * 60 * 1000 - 5 * 60 * 1000 > Date.now()) {
				return true;
			} else {
				return false;
			}
		} else if (loginType === 'withoutabox') {
			// withoutaboxs are logged in for 1 day - 5 minutes
			let lastTouch = autoLogin.filmFreeway;
			if (!lastTouch) {
				return false;
			}

			if (lastTouch + 1 * 24 * 60 * 60 * 1000 - 5 * 60 * 1000 > Date.now()) {
				return true;
			} else {
				return false;
			}
		}

		return false;
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/auto-login.service.ts